import React from 'react';
import { Route } from 'react-router-dom';
import GlobalLoader from 'components/common/loader/GlobalLoader';
import Header from 'components/layout/header/Header';
import Footer from 'components/layout/footer/Footer';
import { GlobalConsumer } from 'context/GlobalProvider';
import ModalComplete from 'components/extensions/modal/ModalComplete';
import SplashScreen from 'components/common/splash-screen/SplashScreen';
import Welcome from 'components/extensions/welcome/Welcome';
import Toast from 'components/ui/toast/Toast';
import ModalCompletePolitica from 'components/extensions/modal/ModalCompletePolitica';

const DefaultLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <GlobalConsumer>
          {context => (
            <>
              <div className="main">
                <Header />
                <main>
                  <Component {...matchProps} context={context} />
                </main>
                <Footer {...matchProps} context={context} />
              </div>
              <ModalComplete context={context} />
              <GlobalLoader context={context} />
              <SplashScreen context={context} />
              <Welcome context={context} />
              <ModalCompletePolitica />
              <Toast />
            </>
          )}
        </GlobalConsumer>
      )}
    />
  );
};

export default DefaultLayout;
